import { Component, OnInit, Input, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { Router } from "@angular/router";
import { SharedService }  from "../../services/shared.service";
import { IBrandProfile } from '../../interfaces/brand-profile';
import { IPageContent } from '../../interfaces/page-content';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-brand-header',
  templateUrl: './brand-header.component.html',
  styleUrls: ['./brand-header.component.css']
})
export class BrandHeaderComponent  implements OnInit, OnChanges {

  @Input() brandProfile: any;
  @Input() pageContent: any;
  @Input() isLogoutVisible: boolean = false;

  brandName!: string;

  headerTitle!: string;
  isHeaderTitleShown: boolean = false;

  headerSubtitle!: string;
  isHeaderSubtitleShown: boolean = false;

  headerAvatar!: string;
  isHeaderAvatarShown: boolean = false;

  brandLogoImage!: any;
  isBrandLogoImageShown: boolean = false;

  environmentBanner: string = environment.environmentBanner;
  isProdEnvironment: boolean = environment.production;

  public brandStyleTheme: any = {};

  constructor(
    private router: Router,
    private sharedService: SharedService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    let change : SimpleChange = changes['brandProfile'];
    if (change && change.currentValue) {
      this.callback();
    }
  }

  callback() {
    console.log('ngOnChanges', this.brandProfile);
    this.makeBrandHeader(this.brandProfile, this.pageContent);
  }

  ngOnInit(): void {
    this.makeBrandHeader(this.brandProfile, this.pageContent);
  }

  makeBrandHeader (brandProfile: IBrandProfile, pageContent: IPageContent) {
    if (brandProfile) {
      // Display the brand name
      this.brandName = brandProfile.brandName;
      // Display the brand logo image, if possible
      this.brandLogoImage = null;
      this.isBrandLogoImageShown = false;
      if (brandProfile.logoImage) {
        this.brandLogoImage = 'data:' + brandProfile.logoImage.imageType + ';base64,' + brandProfile.logoImage.imageContent;
        this.isBrandLogoImageShown = true;
      }
      // Change the background color, if needed
      this.brandStyleTheme = this.sharedService.getBrandStyleScheme(brandProfile);
    }
    if (pageContent) {
      // Display the header title, subtitle, avatar, etc.
      if (pageContent.headerTitle) {
        this.headerTitle = pageContent.headerTitle;
        this.isHeaderTitleShown = true;
      }
      if (pageContent.headerSubtitle) {
        this.headerSubtitle = pageContent.headerSubtitle;
        this.isHeaderSubtitleShown = true;
      }
      if (pageContent.headerAvatar) {
        var loc = '/assets/images/' + pageContent.headerAvatar;
        document.documentElement.style.setProperty(`--avatar-location`, `url(${loc})`);
        this.isHeaderAvatarShown = true;
      }
    }
  }

  signout() {
    localStorage.clear();
    this.router.navigate(['/cv-comp']);
  }  

}
